var _rect, _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuWilliams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_853)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_853)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_853",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.466H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 513.738L368.856 205.431H748.286L-27.857 815.176L-23.587 513.738Z",
    fill: "url(#paint2_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.857 815.176L298.789 558.56H735.272L405.923 817.299L-27.857 815.176Z",
    fill: "url(#paint9_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_3_853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_3_853)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#12A2DD"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.55 315.029H143.868V287.191H137.55V315.029ZM119.172 287.191H112.86V315.029H131.202V309.995H119.172V287.191ZM198.085 302.172L184.603 286.873H183.759V315.052H189.852V304.799C189.874 303.222 189.806 301.646 189.649 300.077C189.649 300.077 190.719 301.721 191.801 303.022L197.669 310.249H198.56L204.398 303.022C205.451 301.726 206.522 300.083 206.522 300.083C206.365 301.652 206.297 303.228 206.319 304.805V315.052H212.412V286.873H211.567L198.085 302.172ZM233.416 298.336L231.981 297.722C230.112 296.93 228.452 296.038 228.452 294.314C228.452 292.92 229.244 292 230.928 292C231.724 292.02 232.499 292.257 233.17 292.685C233.841 293.114 234.382 293.717 234.736 294.43L239.469 291.612C237.472 288.14 234.261 286.757 230.789 286.757C225.663 286.757 222.463 290.119 222.37 294.424C222.272 299.209 225.68 301.368 229.823 303.132L231.258 303.746C233.885 304.903 235.117 305.765 235.071 307.507C235.019 309.15 233.914 310.336 231.547 310.336C228.718 310.336 227.051 308.78 226.05 306.65L221.051 309.509C222.405 312.645 226.155 315.527 231.507 315.527C236.859 315.527 241.187 312.72 241.372 307.559C241.529 303.109 238.549 300.349 233.422 298.301M42.2846 286.96L32.0313 309.179L34.1722 315.029H35.1733L41.3588 301.09C41.9191 299.964 42.378 298.791 42.7301 297.583C43.0854 298.775 43.5362 299.936 44.0783 301.055L50.2985 315.029H51.2996L53.4347 309.179L43.1872 286.96H42.2846ZM30.5038 287.191H24L31.3717 307.379L34.8434 299.811L30.5038 287.191ZM50.5705 299.742L54.0885 307.379L61.4834 287.191H54.916L50.5705 299.742ZM69.9197 315.029H76.2326V287.191H69.9197V315.029ZM94.2857 287.191H87.9729V315.029H106.315V309.995H94.2857V287.191ZM163.935 305.696H160.787L163.183 299.551C163.634 298.393 163.935 297.416 163.935 297.416C163.935 297.416 164.23 298.405 164.681 299.551L167.077 305.667L163.935 305.696ZM164.386 286.902H163.484L151.055 314.988H157.119L158.93 310.533H168.934L170.745 314.988H176.815L164.386 286.902Z",
    fill: "#081E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.268 287.191H349.587V315.029H343.268V287.191ZM330.822 305.713L330.66 305.962C328.878 308.681 326.853 309.844 323.884 309.844C319.255 309.844 315.917 306.188 315.917 301.165C315.917 296.143 319.192 292.555 323.884 292.555C325.154 292.512 326.411 292.807 327.529 293.409C328.647 294.01 329.586 294.898 330.249 295.981L330.411 296.247L335.179 292.862L335.029 292.625C332.57 288.771 328.936 286.902 323.884 286.902C315.72 286.902 309.564 293.03 309.564 301.148C309.564 309.266 315.72 315.434 323.884 315.434C328.919 315.434 332.94 313.305 335.521 309.283L335.671 309.046L330.822 305.713ZM419.977 300.17V299.898H406.668V305.366H413.398C412.686 307.68 410.267 309.879 406.24 309.879C401.548 309.879 398.139 306.211 398.139 301.148C398.139 296.085 401.449 292.538 406.194 292.538C407.489 292.491 408.771 292.801 409.902 293.433C411.033 294.066 411.968 294.997 412.605 296.125L412.767 296.391L417.657 292.92L417.506 292.682C414.989 288.788 411.286 286.896 406.194 286.896C397.977 286.896 391.786 293.024 391.786 301.142C391.786 309.422 397.879 315.428 406.252 315.428C410.534 315.428 414.058 314.109 416.436 311.603C418.987 308.93 420.208 304.978 419.971 300.164M377.951 287.214V298.932C377.951 300.152 377.888 301.304 377.998 302.374C377.252 301.516 376.447 300.71 375.591 299.962L361.837 287.052L361.756 286.971H360.789V315.058H366.622V303.341C366.664 302.183 366.646 301.025 366.569 299.869C367.316 300.737 368.121 301.555 368.976 302.317L382.748 315.22L382.829 315.301H383.795V287.214H377.951ZM268.29 296.461C268.29 299.059 266.942 300.262 264.049 300.262H259.998V292.7H264.049C266.942 292.7 268.29 293.898 268.29 296.461ZM269.447 304.562C272.803 303.115 274.655 300.245 274.655 296.461C274.655 290.675 270.755 287.203 264.24 287.203H253.824V315.041H260.016V305.574H263.129L268.666 315.041H275.76L269.447 304.562ZM293.026 305.696H289.884L292.274 299.551C292.731 298.393 293.026 297.416 293.026 297.416C293.026 297.416 293.327 298.405 293.779 299.551L296.174 305.667L293.026 305.696ZM293.478 286.902H292.575L280.146 314.988H286.216L288.027 310.545H298.026L299.843 315H305.907L293.478 286.902Z",
    fill: "#009CD9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_853",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_853",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_853",
    x1: 64.8378,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_853",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_853",
    x1: 276.23,
    y1: 500.057,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_853",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_853",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_853",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_853",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_853",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_853",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_853",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_853",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#061B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41B48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 33,
    fill: "white",
    transform: "translate(24 285)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuWilliams);
export default __webpack_public_path__ + "static/media/team_menu_williams.5ac0f91d138e180be6606548aef55af5.svg";
export { ForwardRef as ReactComponent };